export const GENERIC_VARIATION = 'GENERIC';
